/* src/components/pages/Resumenventascli.jsx - Modificado el 17-01-2026 */
/* ------------ consulta resumen de ventas clientes ------------------- */

import React, { useState } from 'react';
import { TextField, Box, Button, Stack, Dialog, DialogTitle, Card, DialogActions,
         DialogContent, FormControlLabel, Checkbox, CircularProgress,
         Typography, MenuItem, Divider } from '@mui/material';
import api from '../../services/api.js'; // Api Interceptor en vez de Axios

import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { CustomToolbar } from "../../components/datagrid/CustomToolbar";
import DataGridSkeleton from "../../components/datagrid/DataGridSkeleton";

import { exportPdfAsync, downloadBlob } from "../utils/exportUtils";
import { normalizeRut } from "../utils/rutUtils";
import { formatoCLP } from "../utils/montoclpUtils";

import { RiFolderDownloadLine, RiShareBoxFill, RiFileSearchLine } from "react-icons/ri";

import { useAuth } from "../../context/AuthContext"; // token

import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves

/* Campos para exportar a Csv */
const CSV_FIELDS = [
  { key: 'rut', label: 'RUT Cliente' },
  { key: 'ano', label: 'Año Tributario' },
  { key: 'mes', label: 'Mes Tributario' },
  { key: 'tipodte', label: 'Dte' },
  { key: 'tipo', label: 'Descripción' },
  { key: 'cantdoc', label: 'Cantidad' },
  { key: 'totalexe', label: 'Total Exento' },
  { key: 'totalnet', label: 'Total Neto' },
  { key: 'totaliva', label: 'Total Iva' },
  { key: 'montototal', label: 'Monto Total' },
];


const Resumenventascli = ({ modo }) => {
  const { user } = useAuth();

  const [generandoPdf, setGenerandoPdf] = useState(false);

  const [openCsvDialog, setOpenCsvDialog] = useState(false);

  /* Selecciona todos los campos para Csv */
  const [selectedCsvFields, setSelectedCsvFields] = useState(
    CSV_FIELDS.map(f => f.key)
  );

  const [ano, setAno] = useState(new Date().getFullYear()); // Inicializa con el año actual
  const [mes, setMes] = useState(0); // Inicialmente "Todos"
  const [dataventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(false);

  const [totalExentofa, setTotalExentofa] = useState(0);
  const [totalNetofa, setTotalNetofa] = useState(0);
  const [totalIvafa, setTotalIvafa] = useState(0);
  const [totalBrutofa, setTotalBrutofa] = useState(0);
  const [totalExentonc, setTotalExentonc] = useState(0);
  const [totalNetonc, setTotalNetonc] = useState(0);
  const [totalIvanc, setTotalIvanc] = useState(0);
  const [totalBrutonc, setTotalBrutonc] = useState(0);

  /* Estados para paginación desde el servidor */
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [rowCount, setRowCount] = useState(0);
  
  /* Dialogo y confirmación */
  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes

  /* Limpiar totales cards */
  const limpiar = () => {
    setTotalExentofa(0);
    setTotalNetofa(0);
    setTotalIvafa(0);
    setTotalBrutofa(0);

    setTotalExentonc(0);
    setTotalNetonc(0);
    setTotalIvanc(0);
    setTotalBrutonc(0);
  };

  /* Cálculo dinámico de los años */
  const currentYear = new Date().getFullYear(); // Año actual
  const years = Array.from({ length: 7 }, (_, index) => currentYear - index);

  /* Manejo del cambio del año */
  const handleAnoChange = (e) => {
    setAno(e.target.value);
    setVentas([]);
    limpiar();
  };

  /* Manejo del cambio del mes */
  const handleMesChange = (e) => {
    setMes(e.target.value);
    setVentas([]);
    limpiar();
  };

  /* helper para formato de monto clp */
  const renderMontoCLP = (value) => (
    <Box
      sx={{
        textAlign: 'center',
        fontSize: '0.9rem',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        width: '100%',
        // fontWeight: 'bold',
      }}
    >
      {formatoCLP(value)}
    </Box>
  );

  /* Función obtener los datos */
  const fetchResumenVentas = async ({ page = 0, pageSize = 20 } = {}) => {
    if (!user.usuario) {
      showFeedback({
        message: 'Debe ingresar el Rut',
        severity: 'warning',
      });
      return;
    }

    setLoading(true);

    try {
      const RutCli = normalizeRut(user.usuario);

      const Rutaconsultar = RutCli
      const Anoaconsultar = ano
      const Mesaconsultar = mes

      const response = await api.post('/resumenventas/getresumenventas', {
        Rutaconsultar,
        Anoaconsultar,
        Mesaconsultar,
        page,
        pageSize,
      });

      if (response.data.success && response.data.rows) {
        const ventas = response.data.rows;

        setVentas(ventas);                // Carga los datos al estado //
        setRowCount(response.data.total); // Total registros //

        const t = response.data.totales;

        setTotalExentofa(t.exento_fa);
        setTotalNetofa(t.neto_fa);
        setTotalIvafa(t.iva_fa);
        setTotalBrutofa(t.total_fa);

        setTotalExentonc(t.exento_nc);
        setTotalNetonc(t.neto_nc);
        setTotalIvanc(t.iva_nc);
        setTotalBrutonc(t.total_nc);

      } else {
        setVentas([]);
        setRowCount(0);

        showFeedback({
          message: 'No se encontraron registros para los parámetros ingresados',
          severity: 'warning',
        });
      }

    } catch (err) {
      setVentas([]);
      setRowCount(0);

      showFeedback({
        message: 'No fue posible obtener su solicitud, por favor intente más tarde',
        severity: 'error',
      });

    } finally {
      setLoading(false);
    }
  };

  /* exportar a pdf todos los datos de la tabla */
  const exportToPDF = async () => {
    exportPdfAsync({
      endpointBase: "/resumenventas/pdf",
      payload: {
        Rutaconsultar: normalizeRut(user.usuario),
        Anoaconsultar: ano,
        Mesaconsultar: mes
      },
      onStart: () => setGenerandoPdf(true),
      onFinish: () => setGenerandoPdf(false),
      onError: (msg) => {
        setGenerandoPdf(false);
        showFeedback({
          message: msg,
          severity: "error",
        });
      },
    });
  };

  /* Helpers de Selección de campos para exportar a Csv */
  const toggleCsvField = (fieldKey) => {
    setSelectedCsvFields(prev =>
      prev.includes(fieldKey)
        ? prev.filter(k => k !== fieldKey)
        : [...prev, fieldKey]
    );
  };

  /* Configuración de MUI DataGrid */
  const columns = [
    {
      field: 'ano',
      headerName: "Año",
      width: 80,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'mes',
      headerName: "Mes",
      width: 80,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'tipodte',
      headerName: "Dte",
      width: 50,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'tipo',
      headerName: "Descripción",
      width: 400,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'cantdoc',
      headerName: "Cantidad",
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'totalexe',
      headerName: "Total Exento",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return renderMontoCLP(params.value);
      },
    },
    {
      field: 'totalnet',
      headerName: "Total Neto",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return renderMontoCLP(params.value);
      },
    },
    {
      field: 'totaliva',
      headerName: "Total Iva",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return renderMontoCLP(params.value);
      },
    },
    {
      field: 'montototal',
      headerName: "Monto Total",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return renderMontoCLP(params.value);
      },
    },
  ];

  /* Llama a crear Csv */
  const handleExportCsv = async () => {
    try {
      const RutCli = normalizeRut(user.usuario);

      const response = await api.post('/resumenventas/csv',
        {
          Rutaconsultar: RutCli,
          Anoaconsultar: ano,
          Mesaconsultar: mes,
          fields: selectedCsvFields,
        },
        {
          responseType: 'blob',
        }
      );

      downloadBlob(response.data, "resumen_ventas.csv");
      setOpenCsvDialog(false);

    } catch (error) {
      showFeedback({
        message: 'No fue posible exportar el CSV',
        severity: 'error',
      });
    }
  };

  /* Render */
  return (
    <Box sx={{ width: '100%', pt: 0, overflow: 'visible' }}>
      {/* Barra de Controles */}
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        alignItems="center"
        sx={{
          mb: 1,
          flexShrink: 0,       // 👈 NO se colapsa
        }}
      >
        <TextField
          label="Rut"
          value={user?.usuario || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: { shrink: true },
          }}
          sx={{
            minWidth: 140,
            flexShrink: 0,
            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
              textAlign: 'center',
              letterSpacing: '0.03em',
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        <TextField
          label="Cliente"
          value={user?.nombre || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          sx={{
            minWidth: 260,
            flexGrow: 1,
            flexShrink: 0,

            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        <TextField
          id="mes-input"
          select
          label="Mes"
          value={mes}
          onChange={handleMesChange}
          variant="outlined"
          required
          sx={{ width: 90,
            height: '40px', // Altura del TextField
            '& .MuiOutlinedInput-root': { height: '40px' },
            '& .MuiSelect-select': {
              textAlign: 'center',
            }
          }}
        >
          {/* Opción "Todos" con valor 0 */}
          <MenuItem key="todos-mes" value={0}>
            Todos
          </MenuItem>
          {Array.from({ length: 12 }, (_, i) => (
            <MenuItem key={i + 1} value={i + 1}>
              {i + 1}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          id="ano-input"
          select
          label="Año"
          value={ano}
          onChange={handleAnoChange}
          variant="outlined"
          required
          sx={{ width: 90,
            height: '40px', // Altura del TextField
            '& .MuiOutlinedInput-root': { height: '40px' },
            '& .MuiSelect-select': {
              textAlign: 'center',
            }
          }}
        >
          {years.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </TextField>

        {/* Botón Buscar */}
        <Button
          variant="contained"
          startIcon={<RiFileSearchLine size={18} />}
          onClick={() => {
            setPage(0);
            setRowCount(0);
            setVentas([]);
            limpiar();
            fetchResumenVentas({ page: 0, pageSize });
          }}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,

            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,

            '&:hover': {
              backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
            },
          }}
        >
          Buscar
        </Button>

  
        {/* Botón Exportar a Pdf */}
        <Button
          variant="contained"
          startIcon={<RiFolderDownloadLine size={18} />}
          disabled={dataventas.length === 0}
          onClick={exportToPDF}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,
            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          PDF
        </Button>
  
        {/* Botón Exportar a Csv */}
        <Button
          variant="contained"
          startIcon={<RiShareBoxFill size={18} />}
          disabled={dataventas.length === 0}
          onClick={() => setOpenCsvDialog(true)}
          sx={{
            minWidth: 110,
            height: 40,
            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          CSV
        </Button>
      </Stack>

      {/* Cards de Totales */}
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="flex-start"
        gap={1}   // espacio horizontal y vertical
        sx={{ mt: 1, mb: 1 }}
      >
        {/* CARD 1 - Total Exento Facturas */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
            variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Total Exento FA
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalExentofa)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 2 - Total Neto Facturas */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Total Neto FA
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalNetofa)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 3 - Total iVA Facturas */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Total IVA FA
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalIvafa)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 4 - Total Bruto FA */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Total Bruto FA
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalBrutofa)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 5 - Total Exento NC */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Total Exento NC
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalExentonc)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 6 - Total Neto NC */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Total Neto NC
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalNetonc)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 7 - Total Iva NC */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Total IVA NC
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalIvanc)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 8 - Total Bruto NC */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Total Bruto NC
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalBrutonc)}
            </Typography>
          </Box>
        </Card>

      </Stack>

      {/* Configuración MIU DataGrid */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 285px)', // ajusta según tu layout
          minHeight: 0,
        }}
      >
        <DataGrid
          rows={dataventas}
          columns={columns}
          getRowId={(row) => `${row.ano}-${row.mes}-${row.tipodte}` }
          loading={loading}
          density="compact"
          rowHeight={38}
          headerHeight={40}
          pagination
          disableRowSelectionOnClick

          paginationMode="server"
          rowCount={rowCount}
          pageSizeOptions={[10, 20, 50, 100]}
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={({ page: newPage, pageSize: newPageSize }) => {
            const isPageSizeChange = newPageSize !== pageSize;

            const finalPage = isPageSizeChange ? 0 : newPage;

            setPage(finalPage);
            setPageSize(newPageSize);

            fetchResumenVentas({
              page: finalPage,
              pageSize: newPageSize,
            });
          }}

          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          slots={{
            toolbar: CustomToolbar,
            loadingOverlay: DataGridSkeleton,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 400 },
            },
          }}
          sx={{
            height: '100%',
            width: '100%',
            minWidth: 720,      // scroll horizontal cuando corresponde
            border: 'none',
            // accesibilidad / foco
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
      </Box>

      <Typography variant="caption" color="text.secondary">
        {rowCount.toLocaleString('es-CL')} registros encontrados
      </Typography>

      {/* Dialogo generando pdf */}
      <Dialog
        open={generandoPdf}
        aria-labelledby="generando-pdf-title"
        aria-describedby="generando-pdf-desc"

        maxWidth="xs"
        fullWidth
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 3,
              textAlign: 'center',
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
            }),
          },
        }}
      >
        <DialogContent>
          <Stack spacing={2} alignItems="center" py={2}>
            <CircularProgress
              size={42}
              thickness={4}
              sx={{
                color: (theme) => theme.custom.ui.focus,
              }}
            />

            <Typography id="generando-pdf-title" variant="body2">
              Generando reporte
            </Typography>

            <Typography
              id="generando-pdf-desc"
              variant="caption"
              color="text.secondary"
            >
              Estamos trabajando en ello…
            </Typography>
          </Stack>
        </DialogContent>
      </Dialog>

      {/* Dialogo selección de campos para Csv desde el backend */}
      <Dialog
        open={openCsvDialog}
        onClose={() => setOpenCsvDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Box
            sx={{
              mb: 0,
              color: (theme) => theme.custom.ui.brandAccent,
              fontSize: '1.4rem'
            }}>
            Exportar CSV
          </Box>
        </DialogTitle>

        <Divider />

        <DialogContent>
          <Box sx={{ mb: 1, color: 'text.secondary', fontSize: '0.85rem' }}>
            Selecciona los campos que deseas incluir en el archivo.
          </Box>

          <Stack spacing={0.5}>
            {CSV_FIELDS.map(field => (
              <FormControlLabel
                key={field.key}
                control={
                  <Checkbox
                    checked={selectedCsvFields.includes(field.key)}
                    onChange={() => toggleCsvField(field.key)}
                  />
                }
                label={field.label}
              />
            ))}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenCsvDialog(false)}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.secondaryActionBg,
              color: (theme) => theme.custom.ui.secondaryActionText,
              '&:hover': {
                backgroundColor: (theme) => theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            disabled={selectedCsvFields.length === 0}
            onClick={handleExportCsv}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.primaryAction,
              color: (theme) => theme.custom.ui.primaryActionText,
              '&:hover': {
                backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
              },
            }}
          >
            Exportar
          </Button>

        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default Resumenventascli;
